import { Box, Heading, List, ListItem, Stack, Text } from '@chakra-ui/react';
import type { LegalSection } from '../data/legal';
interface LegalContentProps {
  sections: LegalSection[];
  lastUpdated: string;
}
export function LegalContent({
  sections,
  lastUpdated
}: LegalContentProps) {
  return <Box maxW="820px" data-id="element-108" data-mp="s53i08r2tkl8">
      <Text fontSize="xs" fontWeight={600} letterSpacing="0.12em" textTransform="uppercase" color="navy.400" pb={6} borderBottom="1px solid" borderColor="navy.100" data-id="element-109" data-mp="s4lgawlnae5x">
        {lastUpdated}
      </Text>

      <Stack spacing={{
      base: 10,
      md: 12
    }} mt={{
      base: 10,
      md: 12
    }} data-id="element-110" data-mp="edoze312zlep">
        {sections.map(section => <Box as="section" key={section.heading} data-id="element-111" data-mp="9evl48dyzqdh">
            <Heading as="h2" fontSize={{
          base: 'lg',
          md: 'xl'
        }} mb={4} data-id="element-112" data-mp="9d0zssysdw8v">
              {section.heading}
            </Heading>
            <Stack spacing={4} data-id="element-113" data-mp="1puopqt3vbq63">
              {section.paragraphs.map(paragraph => <Text key={paragraph} fontSize="sm" color="navy.600" lineHeight={1.9} data-id="element-114" data-mp="1kvv9isx75l28">
                  {paragraph}
                </Text>)}
              {section.bullets ? <List spacing={3} pl={5} styleType="none" data-id="element-115" data-mp="yhv6fkizn5aw">
                  {section.bullets.map(bullet => <ListItem key={bullet} fontSize="sm" color="navy.600" lineHeight={1.9} position="relative" _before={{
              content: '""',
              position: 'absolute',
              left: '-18px',
              top: '11px',
              w: '6px',
              h: '1px',
              bg: 'accent.500'
            }} data-id="element-116" data-mp="13gybh4yyxbiv">
                      {bullet}
                    </ListItem>)}
                </List> : null}
            </Stack>
          </Box>)}
      </Stack>
    </Box>;
}